import ModalLayout from "components/modal/modal-layout/ModalLayout";
import type { ComponentPropsWithoutRef, ReactNode } from "react";
import styles from "./DataProcessingModal.module.scss";

type Props = {
  labelTitle?: string;
  children: ReactNode;
  show: boolean;
} & Omit<ComponentPropsWithoutRef<typeof ModalLayout>, "show" | "children">;

const DataProcessingModal = ({
  labelTitle,
  children,
  show,
  onHide,
  ...props
}: Props) => {
  return (
    <ModalLayout
      show={show}
      onHide={onHide}
      backdropClassName={styles["backdrop"]}
      contentClassName={styles["content"]}
      headerClass={styles["header"]}
      bodyClass={styles["body"]}
      Header={<span className={styles["title"]}>{labelTitle}</span>}
      {...props}
    >
      {children}
    </ModalLayout>
  );
};
export default DataProcessingModal;
